<div class="col-md-8">
    <div class="row">
        <div class="col-md-12">
            <div class="post-138 page type-page status-publish hentry">
                <div class="widget-main">
                    <div class="widget-inner">
                        <h3 class="archive-title">Widerruf</h3>
                        <h3 class="wp-block-heading" style="margin-top:0; color:#2a6496;">Widerrufsrecht</h3>
                        <p>Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen.</p>
                        <p>Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses (Einlangen der Rechnung bei dem:der Teilnehmer:in).</p>
                        <p>
                            Um Ihr Widerrufsrecht auszuüben, müssen Sie uns mittels einer eindeutigen Erklärung (z. B. mit der Post versandter Brief oder E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können dafür das beigefügte <a href="/assets/files/OEBAK_Widerruf_Formular.pdf" download>Muster-Widerrufsformular</a>
                            verwenden, das jedoch nicht vorgeschrieben ist.
                        </p>
                        <p>
                            Sie können das <a href="/assets/files/OEBAK_Widerruf_Formular.pdf" download>Muster-Widerrufsformular</a>
                            oder eine andere eindeutige Erklärung auch auf unserer <a routerLink="/widerruf">Webseite</a>
                            elektronisch ausfüllen und übermitteln. Machen Sie von dieser Möglichkeit Gebrauch, so werden wir Ihnen unverzüglich (z. B. per E-Mail) eine Bestätigung über den Eingang eines solchen Widerrufs übermitteln.
                        </p>
                        <p>Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.</p>
                        <h3 class="wp-block-heading" style="margin-top:0; color:#2a6496;">Folgen des Widerrufs</h3>
                        <p>Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.</p>
                        <p>Die Rückzahlung der Teilnahmegebühr erfolgt bei bereits erfolgtem Abruf der Lehrgangsmaterialien abzüglich der dafür anfallenden Kosten.</p>
                        <h3 class="wp-block-heading" style="margin-top:0; color:#2a6496;">Widerrufsformular</h3>
                        <p>Hiermit widerrufe ich den von mir abgeschlossenen Vertrag über die Erbringung der folgenden Dienstleistung:</p>
                        <p>Online bzw. im Präsenzunterricht zur Verfügung gestellten Ausbildungs- und Weiterbildungslehrgänge:</p>

                        <p class="alert alert-info" *ngIf="!istEingeloggt">
                            <fa-icon [icon]="['fas', 'info-circle']" aria-hidden="true"></fa-icon>
                            Bitte loggen Sie sich ein, um das Widerrufsformular online ausfüllen zu können
                        </p>


                        <!-- FORMULAR -->
                        <form [formGroup]="formular" (ngSubmit)="widerrufen()" *ngIf="istEingeloggt">
                            <div class="flex gap-4 mt-5">
                                <div class="flex">
                                    <label for="lehrgang">Lehrgang *</label>
                                    <div class="ml-2" [ngClass]="formular.get('lehrgang') ? 'flex' : 'dropdown-width'">
                                        <p-dropdown id="lehrgang" formControlName="lehrgang" [options]="lehrgaenge" (onChange)="fuegeDatumEin()">
                                            <ng-template let-kurse pTemplate="selectedItem">
                                               <div>
                                                   {{ kurse.kurs.datum | date: 'dd.MM.yyyy' }} | {{ titel(kurse.kurs.typ) }}
                                               </div>
                                            </ng-template>
                                            <ng-template let-kurse pTemplate="item">
                                                <div>
                                                    {{ kurse.kurs.datum | date: 'dd.MM.yyyy' }} | {{ titel(kurse.kurs.typ) }}
                                                </div>
                                            </ng-template>
                                        </p-dropdown>
                                    </div>
                                </div>
                            </div>
                            <div class="flex gap-4 mt-3">
                                <div class="flex">
                                    <label for="lehrgangsDatum">Datum des Lehrgangs</label>
                                    <label id="lehrgangsDatum" class="lehrgangsDatum">{{ lehrgangsDatum | date:'dd.MM.yyyy'}}</label>
                                </div>
                            </div>
                            <div class="flex gap-4 mt-3">
                                <div class="flex">
                                    <label for="vertragsabschluss" class="mr-7 pt-2">Vertragsabschluss am *</label>
                                    <div class="ml-2">
                                        <p-calendar
                                            id="vertragsabschluss"
                                            [ngClass]="formular.get('vertragsabschluss')?.invalid && formular.get('vertragsabschluss')?.touched ? 'invalid-datum' : 'mr-5 datum'"
                                            class="mr-5 datum"
                                            appendTo="body"
                                            formControlName="vertragsabschluss"/>
                                        <div class="invalid-input ml-2">
                                            <div
                                                *ngIf="formular.get('vertragsabschluss')?.errors?.['datumNichtZukuenftig'] && formular.get('vertragsabschluss')?.touched && formular.get('vertragsabschluss')?.value">
                                                Datum muss in der Zukunft liegen
                                            </div>
                                            <div *ngIf="!formular.get('vertragsabschluss')?.getRawValue() && formular.get('vertragsabschluss')?.touched">
                                                Bitte geben Sie ein Datum an.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex gap-4 mt-3">
                                <div class="flex">
                                    <label for="name">Name des Verbrauchers</label>
                                    <label id="name" class="name">{{ name }}</label>
                                </div>
                            </div>
                            <div class="flex gap-4 mt-3">
                                <div class="flex">
                                    <label for="anschrift">Anschrift des Verbrauchers</label>
                                    <label id="anschrift" class="adresse">{{ adresse }}</label>
                                </div>
                            </div>
                            <div class="form-group button">
                                <button [disabled]="!formular.valid" class="btn btn-primary" type="submit" (click)="widerrufen()">Absenden</button>
                            </div>
                            <p>* Pflichtfeld</p>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

